import { createStandardAction } from 'typesafe-actions'
import { SelectionType } from 'types/SelectionType'

export interface AnswerPayload {
  selectionType: SelectionType
  clickedAnswer: string
  questionId: string
}

export const selectAnswer = createStandardAction('@questions/select')<
  AnswerPayload
>()
export const guessVictims = createStandardAction('@questions/guess')<number>()
